import React, { useState } from "react";
import NavBar from "../components/Navbar/NavBar";
import Footer from "../components/Footer";
import { useDocTitle } from "../components/CustomHook";
import { toast } from "react-toastify";
import SVG from "../components/svg/SVG";
import { isMobile } from "react-device-detect";

const serviceList = [
    {
        name: "Accounting & Bookkeeping",
        isVolumeBased: true,
        requiresMoreInfo: false,
    },
    {
        name: "Tax & Statutory Compliance",
        isVolumeBased: false,
        requiresMoreInfo: false,
    },
    {
        name: "Payroll Administration",
        isVolumeBased: true,
        requiresMoreInfo: false,
    },
    {
        name: "Business Advisory",
        isVolumeBased: false,
        requiresMoreInfo: false,
    },
    {
        name: "Financial Statements",
        isVolumeBased: false,
        requiresMoreInfo: false,
    },
    {
        name: "Secretarial Services",
        isVolumeBased: false,
        requiresMoreInfo: false,
    },
    {
        name: "Other (please specify)",
        isVolumeBased: false,
        requiresMoreInfo: true,
    },
];

const QuoteForm = (props) => {
    const [isLoading, setIsLoading] = useState(false);

    useDocTitle("Vero | Demo Product");

    const [firstName, setFirstName] = useState("");
    const [lastName, setLastName] = useState("");
    const [email, setEmail] = useState("");
    const [phone, setPhone] = useState("");
    const [message, setMessage] = useState("");
    const [services, setQuoteServices] = useState([]);

    const [vatRegistered, setVatRegistered] = useState("");
    const [avgMonthlyRevenue, setAvgMonthlyRevenue] = useState("");
    const [aproxMonthlyTrxn, setAproxMonthlyTrxn] = useState("");
    const [employeeCount, setEmployeeCount] = useState("");
    const [usingAccountingSoftware, setUsingAccountingSoftware] = useState("");
    const [accountSoftwareNames, setAccountSoftwareNames] = useState("");

    const [isMessageRequired, setIsMessageRequired] = useState(false);
    const [askVolumeBasedQuestions, setAskVolumeBasedQuestions] = useState(false);

    const handleChange = (checked, service) => {
        const { name } = service;

        let checkedList;
        if (checked === true) {
            checkedList = [...services, service];
        } else {
            checkedList = services.filter((e) => e.name !== name);
        }

        const requiresMoreInfo = checkedList.some((service) => service.requiresMoreInfo);
        const isVolumeBased = checkedList.some((service) => service.isVolumeBased);

        setIsMessageRequired(requiresMoreInfo);
        setAskVolumeBasedQuestions(isVolumeBased);
        setQuoteServices(checkedList);
    };

    const clearInput = () => {
        setIsMessageRequired(false);
        setAskVolumeBasedQuestions(false);
        setQuoteServices([]);
        setFirstName("");
        setLastName("");
        setEmail("");
        setPhone("");

        setVatRegistered("");
        setAvgMonthlyRevenue("");
        setAproxMonthlyTrxn("");
        setEmployeeCount("");
        setUsingAccountingSoftware("");
        setAccountSoftwareNames("");

        setMessage("");
    };

    const submit = (e) => {
        e.preventDefault();

        if (services.length === 0) {
            toast.warn("No Services selected!");
            return;
        }

        setIsLoading(true);

        const googleFormData = new FormData();

        googleFormData.append("entry.941250967", firstName);
        googleFormData.append("entry.1054128895", lastName);
        googleFormData.append("entry.329752076", phone);
        googleFormData.append("entry.577844778", email);

        if (message.trim().length > 0) {
            googleFormData.append("entry.812505081", message);
        }

        services.forEach((service) => {
            googleFormData.append("entry.183099592", service.name);
        });

        if (askVolumeBasedQuestions) {
            googleFormData.append("entry.1112431300", vatRegistered);
            googleFormData.append("entry.544126132", avgMonthlyRevenue);
            googleFormData.append("entry.1332410989", aproxMonthlyTrxn);
            googleFormData.append("entry.1093356414", employeeCount);
            googleFormData.append("entry.981959238", usingAccountingSoftware);

            if (usingAccountingSoftware.toUpperCase() === "YES") {
                googleFormData.append("entry.735303455", accountSoftwareNames);
            }
        }

        const googleFormId = "1FAIpQLScEPn432pzoamG8AplXNnrdPL6C0LE7N0E5YV7Y-iidP-2rUg";
        fetch(`https://docs.google.com/forms/d/e/${googleFormId}/formResponse`, {
            method: "POST",
            mode: "no-cors",
            body: googleFormData,
        })
            .then((_) => {
                console.log("Form submitted successfully!");
                toast.success("Request Successful!");
                clearInput(); // Reset form after successful submission
            })
            .catch((error) => {
                console.error("There was a problem with the fetch operation:", error);
                toast.error("Request Failed!");
            })
            .finally(() => {
                setIsLoading(false);
            });
    };

    return (
        <>
            <div>
                <NavBar />
            </div>
            <div id="quote" className="flex justify-center items-center mt-8 w-full bg-white py-12 lg:py-24">
                <div className="container mx-auto my-8 px-4 lg:px-20" data-aos={isMobile ? null : "zoom-in"}>
                    <form onSubmit={submit} id="quoteForm">
                        <div className="w-full bg-white p-8 my-4 md:px-12 lg:w-9/12 lg:pl-20 lg:pr-40 mr-auto rounded-2xl shadow-2xl">
                            <div className="flex">
                                <h1 className="font-bold text-center lg:text-left fg-primary uppercase text-4xl">
                                    Request a Quote
                                </h1>
                            </div>
                            {serviceList.map((service, i) => {
                                const { name } = service;
                                const inputId = `service-checkbox-${i}`;
                                return (
                                    <div key={inputId} className="flex items-center my-4">
                                        <input
                                            id={inputId}
                                            aria-describedby={inputId}
                                            type="checkbox"
                                            className="bg-gray-50 border-gray-300 focus:ring-3 focus:ring-blue-300 h-4 w-4 rounded"
                                            checked={services.some((serv) => serv.name === name)}
                                            onChange={(e) => handleChange(e.target.checked, service)}
                                        />
                                        <label htmlFor={inputId} className="ml-3 text-lg font-medium text-gray-900">
                                            {name}
                                        </label>
                                    </div>
                                );
                            })}
                            <div className="grid grid-cols-1 gap-5 md:grid-cols-2 mt-5">
                                <div>
                                    <label className="fg-primary">First Name</label>
                                    <input
                                        name="first_name"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="text"
                                        placeholder="First Name*"
                                        value={firstName}
                                        onChange={(e) => setFirstName(e.target.value)}
                                        required={true}
                                    />
                                </div>

                                <div>
                                    <label className="fg-primary">Last Name</label>
                                    <input
                                        name="last_name"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="text"
                                        placeholder="Last Name*"
                                        value={lastName}
                                        onChange={(e) => setLastName(e.target.value)}
                                        required={true}
                                    />
                                </div>

                                <div>
                                    <label className="fg-primary">Email</label>
                                    <input
                                        name="email"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="email"
                                        placeholder="Email*"
                                        value={email}
                                        onChange={(e) => setEmail(e.target.value)}
                                        required={true}
                                    />
                                </div>

                                <div>
                                    <label className="fg-primary">Phone</label>
                                    <input
                                        name="phone_number"
                                        className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                        type="number"
                                        placeholder="Phone*"
                                        value={phone}
                                        onChange={(e) => setPhone(e.target.value)}
                                        required={true}
                                    />
                                </div>
                            </div>
                            {askVolumeBasedQuestions && (
                                <div className="grid grid-cols-1 gap-5 md:grid-cols-2 mt-10">
                                    <div>
                                        <label className="fg-primary">Are you VAT registered?</label>
                                        <select
                                            name="vatRegistered"
                                            className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                            required={askVolumeBasedQuestions}
                                            onChange={(e) => setVatRegistered(e.target.value)}
                                            value={vatRegistered}
                                        >
                                            <option value={""} disabled={true}>
                                                Select an option
                                            </option>
                                            <option value={"Yes"}>Yes</option>
                                            <option value={"No"}>No</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="fg-primary">Average monthly revenue (ZAR)</label>
                                        <select
                                            name="avgMonthlyRevenue"
                                            className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                            required={askVolumeBasedQuestions}
                                            onChange={(e) => setAvgMonthlyRevenue(e.target.value)}
                                            value={avgMonthlyRevenue}
                                        >
                                            <option value={""} disabled={true}>
                                                Select an option
                                            </option>
                                            <option value={"Under R100k"}>Under R100k</option>
                                            <option value={"R100k - R500k"}>R100k - R500k</option>
                                            <option value={"R500k - R1m"}>R500k - R1m</option>
                                            <option value={"Over R1m"}>Over R1m</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="fg-primary">Approximate number of monthly transactions</label>
                                        <select
                                            name="aproxMonthlyTrxn"
                                            className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                            required={askVolumeBasedQuestions}
                                            onChange={(e) => setAproxMonthlyTrxn(e.target.value)}
                                            value={aproxMonthlyTrxn}
                                        >
                                            <option value={""} disabled={true}>
                                                Select an option
                                            </option>
                                            <option value={"Under 50"}>Under 50</option>
                                            <option value={"50 - 150"}>50 - 150</option>
                                            <option value={"150 - 300"}>150 - 300</option>
                                            <option value={"Over 300"}>Over 300</option>
                                        </select>
                                    </div>

                                    <div>
                                        <label className="fg-primary">How many employees are on your payroll?</label>
                                        <input
                                            name="employeeCount"
                                            className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                            type="number"
                                            min={0}
                                            step={1}
                                            value={employeeCount}
                                            onChange={(e) => setEmployeeCount(e.target.value)}
                                            required={askVolumeBasedQuestions}
                                        />
                                    </div>

                                    <div>
                                        <label className="fg-primary">Do you currently use accounting software?</label>
                                        <select
                                            name="vat_registered"
                                            className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                            required={askVolumeBasedQuestions}
                                            onChange={(e) => setUsingAccountingSoftware(e.target.value)}
                                            value={usingAccountingSoftware}
                                        >
                                            <option value={""} disabled={true}>
                                                Select an option
                                            </option>
                                            <option value={"Yes"}>Yes</option>
                                            <option value={"No"}>No</option>
                                        </select>
                                    </div>

                                    {usingAccountingSoftware.toUpperCase() === "YES" && (
                                        <div>
                                            <label className="fg-primary">Accounting Software</label>
                                            <input
                                                name="accountSoftwareNames"
                                                className="w-full bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                                type="text"
                                                value={accountSoftwareNames}
                                                onChange={(e) => setAccountSoftwareNames(e.target.value)}
                                                required={true}
                                            />
                                        </div>
                                    )}
                                </div>
                            )}
                            <div className="mb-5 mt-10">
                                <label className="fg-primary">Message</label>
                                <textarea
                                    name="message"
                                    placeholder={`Let us know if there's anything else we should consider \n(e.g. deadlines, specific services, pain points, special requirements).`}
                                    className="w-full h-32 bg-gray-100 text-gray-900 mt-2 p-3 rounded-lg focus:outline-none focus:shadow-outline"
                                    value={message}
                                    onChange={(e) => setMessage(e.target.value)}
                                    required={isMessageRequired}
                                ></textarea>
                            </div>
                            <div className="my-2 w-1/2 lg:w-2/4">
                                <button
                                    type="submit"
                                    id="submitBtn"
                                    className="uppercase text-sm font-bold tracking-wide bg-primary bg-secondary-hover text-white p-3 rounded-lg w-full 
                                    focus:outline-none focus:shadow-outline"
                                >
                                    {isLoading ? "Loading..." : "Send Message"}
                                </button>
                            </div>
                        </div>
                    </form>
                    <div className="w-full lg:-mt-96 lg:w-2/6 px-8 py-6 ml-auto bg-primary rounded-2xl">
                        <div className="flex flex-col text-white">
                            <div className="flex my-4 w-2/3 lg:w-3/4">
                                <div className="flex flex-col">
                                    <i className="fas fa-map-marker-alt pt-2 pr-2" />
                                </div>
                                <div className="flex flex-col">
                                    <h2 className="text-2xl">Office Address</h2>
                                    <p className="text-gray-400">
                                        26 Pointer Crescent, Garsfontein, Pretoria, South Africa
                                    </p>
                                </div>
                            </div>

                            <div className="flex my-4 w-2/3 lg:w-1/2">
                                <div className="flex flex-col">
                                    <i className="fas fa-phone-alt pt-2 pr-2" />
                                </div>

                                <div className="flex flex-col">
                                    <h2 className="text-2xl">Call Us</h2>
                                    <a className="text-gray-400" href="tel:0713314469">
                                        071 331 4469
                                    </a>

                                    <div className="mt-5">
                                        <h2 className="text-2xl">Send an E-mail</h2>
                                        <a className="text-gray-400" href="mailto:irene@veroaccounting.co.za">
                                            irene@veroaccounting.co.za
                                        </a>
                                    </div>
                                </div>
                            </div>

                            <div className="flex my-4 w-2/3 lg:w-1/2">
                                <a
                                    href="https://www.linkedin.com/company/vero_accounting"
                                    target="_blank"
                                    rel="noreferrer"
                                    className="flex justify-center items-center fg-primary hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-50 ease-in-out mr-5"
                                    aria-label="LinkedIn"
                                >
                                    {SVG.linkedIn}
                                </a>
                                <a
                                    href="https://www.facebook.com/profile.php?id=61575972264023"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex justify-center items-center fg-primary hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-50 ease-in-out mr-5"
                                    aria-label="Facebook"
                                >
                                    {SVG.facebook}
                                </a>
                                <a
                                    href="https://www.instagram.com/vero_accounting/"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="flex justify-center items-center fg-primary hover:text-gray-500 bg-white hover:bg-white-100 rounded-full shadow transition duration-50 ease-in-out"
                                    aria-label="Instagram"
                                >
                                    {SVG.instagram}
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    );
};

export default QuoteForm;
